export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_UPI_REQUEST = "ORDER_UPI_REQUEST";
export const ORDER_UPI_SUCCESS = "ORDER_UPI_SUCCESS";
export const ORDER_UPI_FAIL = "ORDER_UPI_FAIL";
export const ORDER_UPI_RESET = "ORDER_UPI_RESET";

export const UPI_PAY_REQUEST = "UPI_PAY_REQUEST";
export const UPI_PAY_SUCCESS = "UPI_PAY_SUCCESS";
export const UPI_PAY_FAIL = "UPI_PAY_FAIL";
export const UPI_PAY_RESET = "UPI_PAY_RESET";

export const ORDER_COD_REQUEST = "ORDER_COD_REQUEST";
export const ORDER_COD_SUCCESS = "ORDER_COD_SUCCESS";
export const ORDER_COD_FAIL = "ORDER_COD_FAIL";
export const ORDER_COD_RESET = "ORDER_COD_RESET";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_LIST_MY_REQUEST = "ORDER_LIST_MY_REQUEST";
export const ORDER_LIST_MY_SUCCESS = "ORDER_LIST_MY_SUCCESS";
export const ORDER_LIST_MY_FAIL = "ORDER_LIST_MY_FAIL";
export const ORDER_LIST_MY_RESET = "ORDER_LIST_MY_RESET";
